/*
 * Created by: cparaschiv
 * Date: 17.05.2013, 17:18
 */

(function ($) {
    'use strict';

    var ui = kendo.ui,
        DropDownList = ui.DropDownList,
        Select = ui.Select,
        CLOSE = "close",
        ENABLE = "enable",
        ISOPEN = "isOpen",
        OPEN = "open",
        VALUE = "value",
        TEXT = "text",
        CHANGE = "change",
        PROGRESS = "progress",
        REQUESTEND = "requestEnd",
        READONLY = "readonly",
        unwrap = TS.unwrap;

    var TsLateFetchCombo = DropDownList.extend({

        selectionList: null,
        _isOpened: false,
        _isFetching: false,

        init: function (element, options) {
            var me = this,
                vm = options.getViewModel && options.getViewModel(),
                propName = options.selectionList,
                sl;

            if (!propName)
                throw new Error('Configuration does not contain the name of the selection list property');

            //hold a reference to selectionList, needed to pass along various information (selection, etc.)
            if (vm && typeof propName == 'string') {
                sl = TS.Util.getProperty(vm, propName);
            }

            me.emptyText = TS.cultures.current.common.EmptySelection;
            if (sl) {
                me._setSelectionList(sl);
                if (sl.AllowEmptySelection === false)
                    me.emptyText = "";
                else if (typeof sl.EmptyText != "undefined" && sl.EmptyText != null)
                    me.emptyText = sl.EmptyText;
            }

            //set initial index to -1
            me.options.index = -1;
            DropDownList.fn.init.call(this, element, options);
        },

        /* internal */
        _setSelectionList: function (sl) {
            var me = this,
                cfg,
                opts = me.options;

            me.selectionList = sl;
            cfg = me.selectionList.getKendoComboConfig();
            me.options = $.extend(true, {}, me.options, cfg);


            me.selectionList.on('reset', $.proxy(me._resetValue, me));
            me.selectionList.on('beforeClearCache', $.proxy(me._beforeClearCache, me));
            me.selectionList.on('afterClearCache', $.proxy(me._afterClearCache, me));

            if (me.dataSource instanceof TS.LazyDataSource) {
                //reset options
                me.setOptions(me.options);
                //reset datasource
                me.setDataSource(me.selectionList.ListSource);
            }
        },

        _dataSource: function () {
            var me = this,
                options = me.options,
                dataSource = options.dataSource || {};

            if (!(dataSource instanceof TS.LazyDataSource)) {
                dataSource = options.dataSource = new TS.LazyDataSource(dataSource);
            }

            DropDownList.fn._dataSource.call(me);
        },

        // don't let kendo automatically fetch data. The data is fetched by TsLateFetchCombo when the list is opened.
        _fetchData: function () {
        },

        text: function (text) {
            var me = this,
                span = me.span;
            if (text !== undefined) {
                if (text == null)
                    text = "";
                if (text.length > 0)
                    span.text(text);
                else
                    span.text(me.emptyText);
            } else {
                text = span.text();
                if (text === me.emptyText)
                    return "";
                return text;
            }
        },

        _textAccessor: function(text) {
            var me = this;
            DropDownList.fn._textAccessor.call(me, text);
            if (text !== undefined) {
                me.trigger("text");
            }
        },

        _click: function (e) {
            var me = this;
            var selectable = me.options.selectable;
            var singleSelection = selectable !== "multiple" && selectable !== false;
            var selectHandler = function (e) {
                if (me._accept(e))
                    e.preventDefault();
            };

            // AV: Temporary fix
            // The selectionChanging event is fired on before selection which is not the best implementation because
            // in case there is no data change the on before selection event should execute and the selection changing event should not.
            // To avoid a big change now we stop executing the base click and wrongfully the on before selection event too
            var selectedItem = me.dataItem(e.item)[me.options.dataValueField];
            if (singleSelection && selectedItem && selectedItem[me.options.dataValueField] === me.value()) {
                //if (singleSelection && me.listView && me.listView._get(e.item)[0] === me.selectedIndex) {
                e.preventDefault();
                me._blur();
                return;
            }

            me.bind('select', selectHandler);
            DropDownList.fn._click.call(me, e);
            me.unbind('select', selectHandler);
        },

        isCharacterKeyPress: function (evt) {
            if (typeof evt.which == "undefined") {
                // This is IE, which only fires keypress events for printable keys
                return true;
            } else if (typeof evt.which == "number" && evt.which > 0) {
                // In other browsers except old versions of WebKit, evt.which is
                // only greater than zero if the keypress is a printable key.
                // We need to filter out backspace and ctrl/alt/meta key combinations
                return !evt.ctrlKey && !evt.metaKey && !evt.altKey && evt.which != 8;
            }
            return false;
        },


        // CM 20131223 handle Delete key
        _keydown: function (e) {
            var me = this,
                key = e.keyCode,
                keys = kendo.keys,
                selectionList = me.selectionList;

            if (key === 16) { // shift key (allow shift+tab navigation)
                return;
                //} else if (key === keys.DELETE) {
                //    if (!selectionList || !selectionList.AllowEmptySelection)
                //        return;

                //    if (me._current) {
                //        me._current.removeClass("k-state-selected");
                //    }

                //    me.select(-1);
                //    me.value(null);
                //    me.text(null);
                //    me._change();
                //    me._updateSelectionList();
                //    return;
            } else if (key === keys.ESC) {
                me._select(me._oldIndex);
                me._closeList(true);
            }

            // CP 20140205 - open/close list on Enter
            // MS 20150727 - added in kendo framework 2015.1.616        	
            if (key === keys.ENTER || key === keys.TAB) {

                var selectHandler = function (args) {
                    args.focusout = (key === keys.TAB);
                    return me._accept(args);
                };
                me.bind('select', selectHandler);
                DropDownList.fn._keydown.call(me, e);
                me.unbind('select', selectHandler);
                return;
            }

            DropDownList.fn._keydown.call(this, e);
        },

        _inputkeypress: function (e) {
            var me = this;
            if (typeof me.tempFilterInput !== 'undefined' && this.isCharacterKeyPress(e)) {
                me.tempFilterInput += String.fromCharCode(e.charCode || e.keyCode);
            }
        },

        // MS 20150727 - _accept is no longer provider by kendo framework. Rewitten for handling selection.
        _accept: function (args) {
            var me = this,
                selectionList = me.selectionList,
                promise;

            // option1: promises
            if (selectionList && selectionList.onSelectedItemChanging) {
                promise = selectionList.onSelectedItemChanging();
            }

            // promises FTW!
            if (promise) {
                promise.then(function (result) {
                    if (result === false) {
                        me._select(me._oldIndex);
                    } else {
                        me._select(args.item);
                    }
                    me._closeList(args.focusout);
                });
            } else {
                me._select(args.item);
                me._closeList(args.focusout);
            }
            return true;
        },

        _closeList: function (focusout) {
            if (this._isOpened !== true)
                return;

            var me = this,
                activeFilter = me.filterInput && me.filterInput[0] === kendo._activeElement();
            if (me._focusElement) {
                me._focusElement(me.wrapper);
            }

            if (activeFilter && focusout === true) {
                me.wrapper.focusout();
            } else {
                me._blur();
            }
            me._updateSelectionList();
            me.close();
        },

        _updateSelectionList: function () {
            var me = this,
                selectionList = me.selectionList,
                selectedItem = me.listView.selectedDataItems()[0],
                selectedIndex = me.selectedIndex,
                editValue;

            if (selectedIndex !== -1) {
                editValue = selectedItem[selectionList.ValueMember];
            }

            // avoid setting the text property value to "<nespecificat>" or other empty text value
            if (selectedItem && selectedItem[selectionList.ValueMember] == null) {
                selectedItem = $.extend({}, selectedItem);
                selectedItem[selectionList.ListMember] = null;
            }

            selectionList.SelectedItem(selectedItem);
            selectionList.Value(editValue);
        },

        open: function () {
            var me = this,
                shouldFetch = false;

            me._updateFilters();

            if (!me.ul[0].firstChild) {
                shouldFetch = true && !me._isOpened;
            }

            me._open = true;
            me._isOpened = true;

            var filters = me.dataSource.filter();
            if (filters && filters.filters[0].value !== "") {
                var currentValue = me.value(),
                   valueMember = me.selectionList.ValueMember;
                me.filterInput.val("");
                me.search("");
                if (currentValue) {
                    me._select(function (dataItem) {
                        return dataItem[valueMember] == currentValue;
                    });
                }
              
            }

            if (shouldFetch) {
                if (!me._request) {
                    me.tempFilterInput = "";
                    me.wrapper.on("keypress" + me.ns, $.proxy(me._inputkeypress, me));
                    me.dataSource.fetch();
                    me.popup.one("activate", function () {
                        me.wrapper.off("keypress" + me.ns, $.proxy(me._inputkeypress, me));

                        var str = me.tempFilterInput || '',
							strLength = str.length;
                        me.filterInput.val(str);
                        delete me.tempFilterInput;
                        //in IE setSelectionRange moves focus to the input control and the popup will not pop.
                        me.filterInput.one("focus", function () {
                            me.filterInput[0].setSelectionRange(strLength, strLength);
                        });

                        //IE creates an X on the textbox to clear the text but is doesn't properly clear the value.
                        //so we simulate a backspace key down.
                        me.filterInput.on("mouseup", function () {
                            var $input = $(this),
                                oldValue = $input.val();

                            if (oldValue == "") return;

                            // When this event is fired after clicking on the clear button
                            // the value is not cleared yet. We have to wait for it.
                            setTimeout(function () {
                                var newValue = $input.val();

                                if (newValue == "") {
                                    // Gotcha
                                    var enterEvent = $.Event("keydown");
                                    enterEvent.which = 8;
                                    $input.trigger(enterEvent);
                                }
                            }, 1);
                        });
                    });
                }
            } else {
                me.popup.one("activate", me._focusInputHandler);
                me.popup.open();
                me._focusItem();
            }
        },

        _focusInput: function () {
            DropDownList.fn._focusInput.call(this, arguments);

            //fix for ie9, set cursor to the end of the filter input control
            if (this.filterInput && this.filterInput.length) {
                var filterValue = this.filterInput.val(),
                    filterValueLength = filterValue.length;
                this.filterInput[0].setSelectionRange(filterValueLength, filterValueLength);
            }
        },

        _updateFilters: function () {
            var me = this,
                lkp = me.selectionList,
                isLookup = lkp && lkp.propertyType == 'adaptiveLookup',
                lkpFilters,
                trFilters,
                shouldFetch;

            if (!isLookup)
                return;

            lkp.refreshFilterValues();
            lkpFilters = lkp._getFilterValues();
            trFilters = lkp.dataSource.transport._getFilterValues();
            shouldFetch = !TS.Util.areSimilar(lkpFilters, trFilters);
            if (shouldFetch) {
                lkp.updateTransportFilters(false);
            }
        },

        close: function () {
            var me = this;

            me._isOpened = false;
            DropDownList.fn.close.call(me);
            me._isOpened = me.popup && me.popup.visible();
            //setTimeout(function () {
            //    if (me.filterInput.val()) {
            //        me.filterInput.val("");
            //        me.search("");
            //    }
            //}, 0);
        },

        _wrapperMousedown: function (e) {
            if ($(e.target).is(this.filterInput)) {
                this._prevent = false;
                return;
            }
            DropDownList.fn._wrapperMousedown.apply(this, arguments);
        },

        _filterSource: function (filter) {
            var me = this;

            TS.log('_filterSource');

            me._updateFilters();
            me.dataSource._data = [];

            me.dataSource.options.serverFiltering = false;
            DropDownList.fn._filterSource.call(me, filter);

            me._state = "accept";
        },

        // CP 20140205 - open list when searching
        _search: function () {
            var me = this;
            TS.log('_search');
            if (!me._isOpened) {
                me.open();
            }
            DropDownList.fn._search.call(me);
        },

        _accessor: function (value, idx) {
            var me = this,
                element = this.element[0],
                isSelect = this._isSelect;

            // ensure returned value is "number" if value is a numeric string
            if (value === undefined && !isSelect) {
                value = element.value;
                if (typeof value === 'string') {
                    if (me.selectionList && me.selectionList.convertValue) {
                        return me.selectionList.convertValue(value);
                    } else if (TS.isNumeric(value)) {
                        return parseInt(value, 10);
                    } else {
                        return value;
                    }
                }
            }

            return DropDownList.fn._accessor.call(this, value, idx);
        },

        _assignInstance: function (text, value) {
            var me = this;
            if (!value) {
                text = me.emptyText;
                value = null;
            }
            return DropDownList.fn._assignInstance.call(me, text, value);
        },

        value: function (value) {
            var me = this,
                val;

            if (value !== undefined) {
                me._accessor(value);
                me.options.value = value;

                return DropDownList.fn.value.call(this, value);
            } else {
                val = DropDownList.fn.value.call(this, value);
                if (val === "" || val === undefined) {
                    val = null;
                }

                return val;
            }
        },

        _resetValue: function () {
            var me = this;

            /*me.value(null);
             me.text("");
             me.element.val(null);*/
            me.text("");
            me.selectedIndex = -1;


            /*me.dataSource.data([]);*/
        },

        _beforeClearCache: function () {
            var me = this;
            // prevent reseting text and value during data([])
            me._fetch = true;
            me.listView._skipUpdate = true;
        },

        _afterClearCache: function () {
            var me = this;

            me._fetch = false;
            me.listView._skipUpdate = false;
            //notify the list that it is unbound
            me.listView._bound = false;
            // CP 20140206 - push filter values to transport filters
            if (me.selectionList.propertyType == 'adaptiveLookup')
                me.selectionList.refreshFilterValues();
        },


        _focusinHandler: function () {
        	DropDownList.fn._focusinHandler.apply(this, arguments);
        	this.element.trigger('tooltipFocus');
        },

        _focusoutHandler: function () {
        	DropDownList.fn._focusoutHandler.apply(this, arguments);
        	this.element.trigger('tooltipBlur');
        },


        options: {
            name: 'TsLateFetchCombo',
            autoBind: false,
            animate: false,
            filter: "startswith",
            suggest: true
        }
    });

    ui.plugin(TsLateFetchCombo);

    /* ko binding */
    ko.kendo.bindingFactory.createBinding({
        name: "kendoTsLateFetchCombo",
        events: {

            change: {
                writeTo: VALUE,
                value: VALUE
            },

            open: {
                writeTo: ISOPEN,
                value: true
            },

            //        close: {
            //            writeTo: ISOPEN,
            //            value: false
            //        },
            // CP 20130529 - modified default config; don't care about ISOPEN at the moment
            // it's more important that the combo pushes both VALUE and TEXT to domain
            // so: intercept close event, read TEXT value, write to TEXT property
            close: {
                writeTo: TEXT,
                value: TEXT
            },

            text: {
                writeTo: TEXT,
                value: TEXT
            },
        },
        watch: {
            enabled: ENABLE,
            readonly: READONLY,
            isOpen: [OPEN, CLOSE],
            data: function (value) {
                ko.kendo.setDataSource(this, value);
            },
            value: VALUE,
            text: function (value) {
                var me = this;
                if (typeof value === 'undefined') {
                    return me.text();
                }
                // delay setting text, meanwhile the value can be updated
                setTimeout(function () {
                    me.text(value);
                }, 0);
            },
            visible: ko.wrapperVisible
        }
    });

    //CP 20130529 - intercept the setup function to pass along the viewModel to widget options
    var prevSetup = ko.bindingHandlers['kendoTsLateFetchCombo'].setup;
    ko.bindingHandlers['kendoTsLateFetchCombo'].setup = function (element, options, context) {
        // bindingFactory converts observables to JS in getWidget
        // so create a closure to hold the reference to our viewModel
        // widget = $element[widgetConfig.name](-->  ko.toJS(options)  <---  ).data(widgetConfig.name);
        options.getViewModel = function () {
            var vm = context.$data;   // PBS: use $data instead of $root to expose proper context in foreach bindings
            return vm;
        };

        if (options.selectionList) {
            var selectionList = TS.getPropertyValue(context.$data, options.selectionList);
            if (selectionList) {
                options.value = TS.accessor(selectionList.Domain(), ts.unwrap(selectionList.EditMember)).value;
                options.text = TS.accessor(selectionList.Domain(), ts.unwrap(selectionList.DisplayMember)).value;
            }
        }

        options.animate = false;
        options.autobind = false;

        prevSetup.apply(this, arguments);
    };


})(jQuery);